module.exports = __webpack_public_path__ + "static/media/NINE.30918a80.png";